import React from 'react';
import { Box, Button, SpaceBetween } from '@amzn/awsui-components-console';
import SupportPromptGroup from '@amzn/awsui-chat-components-console/support-prompt-group';
import type { SuggestedAction } from '../../types/agent-messages';

export interface SuggestedActionsProps {
  actions: SuggestedAction[];
  onActionClick?: (action: string) => void;
}

export const SuggestedActions: React.FC<SuggestedActionsProps> = ({ actions, onActionClick }) => {

  if (!actions || actions.length === 0) return null;

  const navActions = actions.filter(a => a.url);
  const chatActions = actions.filter(a => !a.url);

  return (
    <Box margin={{ top: 's' }}>
      <Box variant="small" color="text-body-secondary" margin={{ bottom: 'xxs' }}>
        What's next?
      </Box>
      {navActions.length > 0 && (
        <Box margin={{ bottom: 'xs' }}>
          <SpaceBetween direction="horizontal" size="xs">
            {navActions.map((a) => (
              <Button
                key={a.action}
                variant="link"
                iconName="external"
                onClick={() => window.open(a.url!, '_blank')}
              >
                {a.label}
              </Button>
            ))}
          </SpaceBetween>
        </Box>
      )}
      {chatActions.length > 0 && (
        <SupportPromptGroup
          ariaLabel="Suggested next actions"
          alignment="horizontal"
          onItemClick={({ detail }) => {
            const action = chatActions.find(a => a.action === detail.id);
            if (action && onActionClick) {
              onActionClick(action.label);
            }
          }}
          items={chatActions.map((a) => ({
            id: a.action,
            text: a.label,
          }))}
        />
      )}
    </Box>
  );
};
